export const BlueAlertIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22.35C17.5228 22.35 22 17.8728 22 12.35C22 6.82713 17.5228 2.34998 12 2.34998C6.47715 2.34998 2 6.82713 2 12.35C2 17.8728 6.47715 22.35 12 22.35ZM12 6.34998C12.5523 6.34998 13 6.79769 13 7.34998V12.9654C13 13.5176 12.5523 13.9654 12 13.9654C11.4477 13.9654 11 13.5176 11 12.9654V7.34998C11 6.79769 11.4477 6.34998 12 6.34998ZM12 15.8115C12.5523 15.8115 13 16.2592 13 16.8115V17.35C13 17.9023 12.5523 18.35 12 18.35C11.4477 18.35 11 17.9023 11 17.35V16.8115C11 16.2592 11.4477 15.8115 12 15.8115Z"
        fill="#0374D6"
      />
    </svg>
  )
}
